import { FCX } from "@datassential/platform-ui-lib";
import { AsideButton } from "./AsideButtons";
import { FiCopy } from "react-icons/fi";
import { FaCheck } from "react-icons/fa";
import { copyTableData } from "@core/utils/string";
import { FC, useCallback, useMemo, useState } from "react";
import { toast } from "react-toastify";
import cn from "classnames";

const CopyTableButton: FCX<{
    data: string[][];
}> = ({
    data,
    className,
    style,
    testId,
}) => {
    const [isSuccess, setIsSuccess] = useState(false);

    const onClick = useCallback(
        () => {
            copyTableData(data);
            toast.success('Table copied to clipboard');

            setIsSuccess(true);
            setTimeout(() => {
                setIsSuccess(false);
            }, 2000);
        },
        [data]
    );

    const Icon: FC<{ className?: string}> = useCallback(
        ({ className, ...rest }) => {
            const props = {
                className: cn("appears", className),
                ...rest,
            };
            return isSuccess ? (
                <FaCheck {...props}/>
            ) : (
                <FiCopy {...props}/>
            );
        },
        [isSuccess]
    );

    const title = useMemo(
        () => isSuccess ? "done!" : "copy table",
        [isSuccess]
    );

    return (
        <AsideButton
            title={title}
            icon={Icon}
            onClick={onClick}
            className={className}
            testId={testId}
            style={style}
            isDisabled={isSuccess}
        />
    );
}

export default CopyTableButton;